import SetVisibilityOfSchedule from './SetVisibilityOfSchedule';
import './SetVisibilityOfSchedule.scss';

export default SetVisibilityOfSchedule;
